import React from "react";
// import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { formatDateFromISO } from "../../../core/util/functions";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplaySecurityEarningsEstimate } from "../../../data/reports/securityStatistics/hooks/useDisplaySecurityEarningsEstimate";

export interface DisplaySecurityEarningsEstimateProps {
	symbol?: string;
}

export const DisplaySecurityEarningsEstimate: React.FunctionComponent<DisplaySecurityEarningsEstimateProps> = ({
	symbol,
}) => {
	const earnings_estimate = useDisplaySecurityEarningsEstimate(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4 } = React.useContext(
		LocalizationContext
	);

	console.log(earnings_estimate)

	const [auth] = useAuth();


	return (
		<div className={style.root}>

			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("period")}</span>
				<span className={style.value}>
					{earnings_estimate?.period
						? getString(earnings_estimate.period as any)
						: ""}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("estimateDate")}</span>
				<span className={style.value}>
					{formatDateFromISO(earnings_estimate?.date)}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("numberOfAnalysts")}</span>
				<span className={style.value}> {getFormatedNumberString4(earnings_estimate?.number_of_analysts)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("avgEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString4(earnings_estimate?.avg_estimate, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("lowEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString(earnings_estimate?.low_estimate, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("highEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString(earnings_estimate?.high_estimate, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("yearAgoEPS")}</span>
				<span className={style.value}> {getFormatedNumberString(earnings_estimate?.year_ago_eps, true)}</span>
			</div>
		</div>
	);
};

